var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.6C4 2.48366 3.28365 3.2 2.4 3.2C1.51634 3.2 0.799999 2.48366 0.799999 1.6C0.799999 0.716344 1.51634 3.86258e-08 2.4 0C3.28365 -3.86258e-08 4 0.716344 4 1.6Z",
    fill: "#150823"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 8.88366 3.28366 9.6 2.4 9.6C1.51634 9.6 0.799999 8.88366 0.799999 8C0.799999 7.11634 1.51634 6.4 2.4 6.4C3.28366 6.4 4 7.11634 4 8Z",
    fill: "#150823"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 16C3.28366 16 4 15.2837 4 14.4C4 13.5163 3.28366 12.8 2.4 12.8C1.51634 12.8 0.8 13.5163 0.8 14.4C0.8 15.2837 1.51634 16 2.4 16Z",
    fill: "#150823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotIcon);
export default __webpack_public_path__ + "static/media/three-dot-icon.54d9dc3de977bee157b1a44c01e227a7.svg";
export { ForwardRef as ReactComponent };